import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { generateICSContent, downloadICSFile } from './generateCalendarInvite';
import { MYLEARNING_URL_FRAGMENT } from '../../constants/Navigation';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VIEW_REGISTERED_EVENTS_TO = `${MYLEARNING_URL_FRAGMENT}?contentType=LIVE_EVENT`;
export function RegistrationConfirmationModal({
  liveEventTitle,
  liveEventDescription,
  onClose,
  session
}) {
  const handleDownloadCalendarInvite = () => {
    const icsContent = generateICSContent({
      title: liveEventTitle,
      description: liveEventDescription,
      startTime: session.startTime,
      endTime: session.endTime,
      location: session.platformLink
    });
    downloadICSFile(icsContent, `${liveEventTitle}.ics`);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "success",
    width: 593,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.confirmationModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.confirmationModal.emailSent",
          options: {
            eventTitle: liveEventTitle
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.confirmationModal.addToCalendar"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsxs(Button, {
        onClick: handleDownloadCalendarInvite,
        use: "primary",
        children: [/*#__PURE__*/_jsx(DownloadIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.liveEventOverviewModal.confirmationModal.downloadCalendarInvite"
        })]
      }), /*#__PURE__*/_jsx(RouterLink, {
        to: VIEW_REGISTERED_EVENTS_TO,
        children: /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.liveEventOverviewModal.viewRegisteredEvents"
          })
        })
      })]
    })]
  });
}